import React from 'react';
import { I18n } from '../../../helpers/i18n';
import { formatRating } from '../../../helpers/utils';
import starActive from '../../../static/images/mvp/star_active.png';
import starInactive from '../../../static/images/mvp/star_in_active.png';
import starInactiveWithBorder from '../../../static/images/mvp/star_in_active_with_border.png';
import './CompactRatingDisplay.css';

function CompactRatingDisplay({
  score = 0,
  hasRating = false,
  onClick,
  isOnTopic = false,
  isUserRating = false,
  isOnCardSession = false,
}) {
  if (hasRating) {
    //----------------------------------------------------------------------------------------
    // Nếu là trên card session thì hiển thị điểm trước sao sau
    //----------------------------------------------------------------------------------------
    if (isOnCardSession) {
      return (
        <div
          className="compact-rating"
          onClick={(e) => {
            e.stopPropagation();
            onClick && onClick(e);
          }}
        >
          <span className="compact-rating-score score-on-card-session">{formatRating(score)}</span>
          <img src={starActive} alt="compact-rating-star" className="compact-rating-star" />
        </div>
      );
    }

    return (
      <div
        className="compact-rating"
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick(e);
        }}
      >
        <img src={starActive} alt="compact-rating-star" className="compact-rating-star" />
        <span className="compact-rating-score">{formatRating(score)}</span>
      </div>
    );
  }

  // Nếu là diểm rating của user mà hông có rating thì không hiển thị gì
  if (isUserRating) {
    return null;
  }

  if (isOnTopic) {
    return (
      <div
        className="compact-rating-no-bg"
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick(e);
        }}
      >
        <img src={starInactive} alt="compact-rating-star" className="compact-rating-star" />
        <span className="compact-rating-none">{I18n.t('no_rating')}</span>
      </div>
    );
  }

  return (
    <div
      className="compact-rating-no-bg"
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick(e);
      }}
    >
      <span className="compact-rating-none">{I18n.t('no_rating')}</span>
      <img src={starInactiveWithBorder} alt="compact-rating-star" className="compact-rating-star" />
    </div>
  );
}

export default CompactRatingDisplay;
